__turbopack_context__.v({
  "MenuAction": "ONSVfa_MenuAction",
  "bun": "ONSVfa_bun",
  "burger": "ONSVfa_burger",
  "close": "ONSVfa_close",
  "closed": "ONSVfa_closed",
  "isClicked": "ONSVfa_isClicked",
  "menu": "ONSVfa_menu",
  "offCanvas": "ONSVfa_offCanvas",
  "opened": "ONSVfa_opened",
  "sticky": "ONSVfa_sticky",
  "wrapper": "ONSVfa_wrapper",
});
